import { render, staticRenderFns } from "./singleImage3.vue?vue&type=template&id=d5cb14d2&scoped=true"
import script from "./singleImage3.vue?vue&type=script&lang=js"
export * from "./singleImage3.vue?vue&type=script&lang=js"
import style0 from "./singleImage3.vue?vue&type=style&index=0&id=d5cb14d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5cb14d2",
  null
  
)

export default component.exports